import { render, staticRenderFns } from "./ModalReportarPrograma.vue?vue&type=template&id=f52d97d2"
import script from "./ModalReportarPrograma.vue?vue&type=script&lang=js"
export * from "./ModalReportarPrograma.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports